import { AlpineComponent } from "alpinejs";
import { PasswordResetService, ResetPasswordParameters } from "../api";

type ResetPassword = AlpineComponent<{
	email: string;
	newPassword: string;
	confirmPassword: string;
	loginUrl: string;
	token: string;
	showErrorMessage: boolean;
	showSuccessMessage: boolean;
	submissionErrors: string[];
	resetPassword: () => void;
}>;

export default (email: string, token: string, loginUrl: string): ResetPassword => {
	return {
		email: email || "",
		newPassword: "",
		confirmPassword: "",
		loginUrl: loginUrl,
		showErrorMessage: false,
		showSuccessMessage: false,
		submissionErrors: [],
		token: token,
		async resetPassword() {
			const resetPasswordParameters: ResetPasswordParameters = {
				email: this.email,
				newPassword: this.newPassword,
				token: this.token,
				confirmPassword: this.confirmPassword,
			};

			const response = await PasswordResetService.resetPassword({ body: resetPasswordParameters });

			this.submissionErrors = [];

			if (response.response.status !== 200 && response.error != null) {
				for (const error of response.error) {
					this.submissionErrors.push(error);
				}
				this.showErrorMessage = true;
				this.showSuccessMessage = false;
			} else {
				this.showSuccessMessage = true;
				this.showErrorMessage = false;
				setTimeout(() => {
					window.location.href = this.loginUrl;
				}, 2000);
			}
		},
	};
};
